module.exports = __webpack_public_path__ + "static/photo11-445f2d0f72f8a05926e885a2c3e84f5e.png";